import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';
import { V2NavSection } from '../../components/navigation/SideNav';
import './PlaceholderPage.css';

interface PlaceholderPageProps {
  section: V2NavSection;
  title: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ section, title }) => {
  return (
    <DashboardLayout activeSection={section}>
      <div className="v2-placeholder-page">
        <h1>{title}</h1>
        <p>This section will be built in upcoming design iterations.</p>
      </div>
    </DashboardLayout>
  );
};

export default PlaceholderPage;
